import PropTypes from 'prop-types';
import * as yup from 'yup';
import { withFormik, Form } from 'formik';
import { Button, SsnInput, Error, Legal } from '@figure/frontlib-gui';
import { FormErrorHandler, Typography } from 'shared/components';
import { uuidv4 } from 'shared/utils';

const ssnRegexp = /^$|^([0-9]{9})$/;

const SsnForm = ({ values, errors, touched, handleSubmit, setFieldValue, serverError }) => {
  const randomId = uuidv4();
  return (
    <>
      <Typography.PageHeader>
        We could not identify you from the information you provided.
      </Typography.PageHeader>
      <FormErrorHandler errors={errors} touched={touched} serverError={serverError} />
      <Form onSubmit={handleSubmit}>
        {!values.hasSsn && (
          <SsnInput
            data-test-id="ssn-description"
            id={`ssn-${randomId}`}
            label="Social Security Number or Individual Taxpayer Identification Number"
            name={`ssn-${randomId}`}
            value={values.ssn}
            autoComplete="new-ssn"
            errorText={touched.ssn && errors.ssn}
            onChange={(value) => setFieldValue('ssn', value)}
            required
          />
        )}

        <Legal>
          Provide us your social security number to try again. This soft credit pull will not affect
          your credit score.
        </Legal>

        <Error display="block">{serverError}</Error>

        <Button onClick={handleSubmit} primary large center>
          Submit
        </Button>
      </Form>
    </>
  );
};

SsnForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default withFormik({
  enableReinitialize: true,

  mapPropsToValues: (props) => ({
    ssn: '',
    hasSsn: props.profile.hasSsn,
  }),

  validationSchema: (props) =>
    yup.object().shape({
      ssn: yup.string().when('hasSsn', {
        is: false,
        then: yup
          .string()
          .required('Required')
          .test('is-ssn', 'Invalid', (value) => !value || value.match(ssnRegexp)),
      }),
      hasSsn: yup.bool(),
    }),

  handleSubmit: (values, { props }) => props.handleSubmit(values),
})(SsnForm);
